<script>
    export let value;

    export let comment_tags;

    function updateValue() {
        value = [];
        for (let tag of comment_tags) {
            if (selected_tags[tag.tag_id]) {
                value.push({
                    id: tag.tag_id,
                    color_class: tag.color_class,
                    name: tag.name
                })
            }
        }
    }

    let selected_tags = {};
    function updateSelected(value) {
        selected_tags = {};
        for (let tag of Object.values(value)) {
            selected_tags[tag.id] = true;
        }
    }

    $: updateSelected(value);
</script>

{#if comment_tags}
<div class="field">
    <div class="tags">
        {#each comment_tags as tag}
            <label class="tag pointer is-{tag.color_class}" class:is-light={!selected_tags[tag.tag_id]}>
                {tag.name}
                <input type="checkbox" name="tag_{tag.tag_id}" bind:checked={selected_tags[tag.tag_id]} on:change={updateValue} />
            </label>
        {/each}
    </div>
</div>
{/if}

<style>
    .tag input {
        display: none;
    }
</style>